module.exports = __webpack_public_path__ + "static/media/ic_open_in_new_selected.f74eb430.svg";